import Head from "next/head";

/**
 * Above-the-fold critical CSS for the Homepage screen only (src/screens/Homepage).
 * Rules below are copied verbatim from src/styles/generated/tailwindInline.js
 * (the full Step 1 bundle, which already inlines every Tailwind rule site-wide),
 * so this is a deliberate duplicate of a small subset for faster first paint —
 * not a replacement for it. Below-the-fold Homepage content still relies solely
 * on the Step 1 bundle. Breakpoints match this project's tailwind.config.js
 * overrides (xs:0px, sm:600px, md:900px), not Tailwind's defaults.
 */
const CRITICAL_CSS = `.mx-4{margin-left:1rem;margin-right:1rem}.my-4{margin-bottom:1rem;margin-top:1rem}.my-10{margin-bottom:2.5rem;margin-top:2.5rem}@media (min-width:0px){.xs\\:my-4{margin-bottom:1rem;margin-top:1rem}}@media (min-width:600px){.sm\\:my-6{margin-bottom:1.5rem;margin-top:1.5rem}}`;

const HomepageCritical = () => (
  <Head>
    <style
      key="homepage-critical-css"
      dangerouslySetInnerHTML={{ __html: CRITICAL_CSS }}
    />
  </Head>
);

export default HomepageCritical;
